import { memo } from 'react';
import Slider from '@dtvgo/slider';
import { ProgressBarClassNames } from './utils.js';
import { useSeekableEnd } from './ProgressBarContext.js';
import { jsx } from 'react/jsx-runtime';
import '@dtvgo/classnames';

/* External */
function SeekableEndFill(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  return /*#__PURE__*/jsx(Slider.FillTemplate, {
    className: ProgressBarClassNames.element('seekable-end-fill', className),
    value: useSeekableEnd()
  });
}
var SeekableEndFill$1 = /*#__PURE__*/memo(SeekableEndFill);

export { SeekableEndFill$1 as default };
//# sourceMappingURL=SeekableEndFill.js.map
